
document.addEventListener("DOMContentLoaded", function () {
  const swatches = document.querySelectorAll('[class^="orichi-swatches-collection-"]');
  swatches.forEach(function (swatch) {
    const parent = swatch.parentElement;
    if (parent) {
      parent.style.zIndex = "0";
      
    }
  });
});


document.addEventListener("DOMContentLoaded", function () {
  const form = document.getElementById("QuickOrderList");
  const next = form?.nextElementSibling;

  if (next?.getAttribute("name") === "orichi-swatches") {
    next.remove();
  }
});

